import useRepo from '@/nebula/repo';
import { EVENTS } from '@/lib/constants';
import { EventBus } from '@/lib/event-bus';
import { RESULT } from 'shared/api/query/constants';
import { calculatedCurrentsByGoalIds, goalById, goalChildren, goalParents } from '@/api/query/nebula/goal';
import { getParentTreeWithAggregations } from '@/lib/goal/goal-parent-tree';
import { goal as goalConfig } from 'shared/api/query/configs.json';
import { updateListForGoal } from '@/api/query/nebula/update';

export default function useGoals() {
  const repo = useRepo(goalConfig.model);
  const getGoals = ({
    queries,
    customFuncHandler = [],
  }) => repo.query(queries, { interceptors: customFuncHandler });

  const getGoal = (id) => repo.query(
    [
      ...goalById(id, RESULT),
      ...goalParents(id, 'goalParents'),
      ...goalChildren(id, 'children'),
      ...updateListForGoal(id, 'updates'),
    ],
  )
    .then((data) => {
      if (data[RESULT].length === 0) {
        return data;
      }

      if (typeof data[RESULT][0] === 'undefined') {
        return data;
      }

      repo.updateSingle({ uid: id, updatesLoaded: true }, { commitToRemote: false });

      return data;
    });

  const loadCalculatedProgresses = (goalIds) => repo.query(
    calculatedCurrentsByGoalIds(goalIds),
  );

  const updateGoalParentsProgress = (goalIds) => {
    const goalParentsWithAggregation = getParentTreeWithAggregations(goalIds, repo);
    return loadCalculatedProgresses([...goalIds, ...goalParentsWithAggregation]);
  };

  const createMultiple = (goals) => repo.createMultiple(goals).then((goals) => {
    EventBus.$emit(EVENTS.GOAL.GOALS_CREATED, { goals });
    return goals;
  });

  const mutateMultiple = (goals) => {
    const goalsToCreate = goals.filter((g) => g.uid === undefined || g.uid === 0);
    return repo.mutateMultiple(goals).then((goals) => {
      EventBus.$emit(EVENTS.GOAL.GOALS_CREATED, { goals: goalsToCreate });
      return goals;
    });
  };

  return {
    ...repo,
    goals: repo.entityList,
    getGoals,
    getGoal,
    createMultiple,
    mutateMultiple,
    updateGoalParentsProgress,
  };
}
